import React, { useState } from 'react';
import { useCalendar } from '../hooks/useCalendar';
import { usePosts } from '../hooks/usePosts';
import { useClients } from '../hooks/useClients';
import CalendarWidget from '../components/CalendarWidget';

const STATUS_FILTERS = [
  { value: 'all', label: 'Todos' },
  { value: 'draft', label: 'Rascunho' },
  { value: 'em_producao', label: 'Em Producao' },
  { value: 'aprovado', label: 'Aprovado' },
  { value: 'publicado', label: 'Publicado' },
];

function Calendar() {
  const { allPosts, postsByWeek, loading, error } = useCalendar();
  const { refetch } = useClients();
  const { updatePostStatus } = usePosts({ onUpdate: refetch });
  const [view, setView] = useState('by-week');
  const [statusFilter, setStatusFilter] = useState('all');

  const filterPosts = (posts) => {
    if (statusFilter === 'all') return posts;
    return posts.filter(p => p.status === statusFilter);
  };

  if (loading) {
    return (
      <div className="loading">
        <div className="loading-spinner" />
        Carregando calendario...
      </div>
    );
  }

  if (error) {
    return (
      <div className="empty-state">
        <div className="empty-state-icon">&#x26A0;</div>
        <p>Erro ao carregar: {error}</p>
      </div>
    );
  }

  const filteredAll = filterPosts(allPosts);

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Calendario</h1>
        <p className="page-subtitle">
          {allPosts.length} posts agendados — visao unificada de todos os clientes
        </p>
      </div>

      <div className="filter-bar">
        {STATUS_FILTERS.map(f => (
          <button
            key={f.value}
            className={`filter-chip ${statusFilter === f.value ? 'active' : ''}`}
            onClick={() => setStatusFilter(f.value)}
          >
            {f.label}
          </button>
        ))}
      </div>

      <div className="tabs">
        <button
          className={`tab ${view === 'by-week' ? 'active' : ''}`}
          onClick={() => setView('by-week')}
        >
          Por Semana
        </button>
        <button
          className={`tab ${view === 'all' ? 'active' : ''}`}
          onClick={() => setView('all')}
        >
          Todos
        </button>
      </div>

      {view === 'by-week' && (
        <div>
          {Object.entries(postsByWeek).map(([week, posts]) => {
            const filtered = filterPosts(posts);
            if (filtered.length === 0) return null;
            return (
              <div key={week}>
                <div className="week-header">{week}</div>
                <div className="card" style={{ marginBottom: 'var(--spacing-lg)' }}>
                  <CalendarWidget posts={filtered} showClient onChangeStatus={updatePostStatus} />
                </div>
              </div>
            );
          })}
        </div>
      )}

      {view === 'all' && (
        <div className="card">
          <CalendarWidget posts={filteredAll} showClient onChangeStatus={updatePostStatus} />
        </div>
      )}
    </div>
  );
}

export default Calendar;
